import React from 'react';
import styled, { css } from 'styled-components';
import Typography from './Typography';
import ErrorIcon from 'images/clear_circle.svg';

// type RootProps = {
//   id?: string;
//   className?: string;
//   style?: any;
//   endAdornment?: ReactNode;
//   errorMessage?: string;
// };
//
// type InputProps = {
//   autoComplete?: string;
//   autoFocus?: boolean;
//   disabled?: boolean;
//   error?: boolean;
//   label?: string;
//   name?: string;
//   placeholder?: string;
//   readOnly?: boolean;
//   ref?: any;
//   type?: string;
//   value?: string;
//   onBlur?: (event: FocusEvent) => void;
//   onChange?: (event: ChangeEvent) => void;
//   onFocus?: (event: FocusEvent) => void;
//   onKeyPress?: (event: KeyboardEvent) => void;
// };

const TextInput = React.forwardRef(
  (
    {
      id,
      className,
      style,
      autoComplete,
      autoFocus = false,
      disabled = false,
      endAdornment,
      error = false,
      errorMessage,
      label,
      name,
      placeholder,
      readOnly = false,
      type = 'text',
      value,
      onBlur,
      onChange,
      onFocus,
      onKeyPress
    },
    ref
  ) => {
    const rootProps = {
      id,
      className,
      style,
      endAdornment
    };

    const inputProps = {
      autoComplete,
      autoFocus,
      disabled,
      error,
      name,
      placeholder,
      readOnly,
      ref,
      type,
      value,
      onBlur,
      onChange,
      onFocus,
      onKeyPress
    };

    return (
      <>
        {label ? (
          <StyledLabel {...rootProps}>
            {label}
            <StyledInput {...inputProps} />
            {endAdornment}
          </StyledLabel>
        ) : (
          <>
            {endAdornment ? (
              <AdornmentContainer {...rootProps}>
                <StyledInput {...inputProps} />
                {endAdornment}
              </AdornmentContainer>
            ) : (
              <StyledInput {...rootProps} {...inputProps} />
            )}
          </>
        )}
        {error && errorMessage && (
          <StyledDiv>
            <StyledImg src={ErrorIcon} />
            <Typography color="error" variant="captionBold">
              {errorMessage}
            </Typography>
          </StyledDiv>
        )}
      </>
    );
  }
);

const rootStyles = css`
  width: 100%;
`;

const adornmentContainerStyles = css`
  position: relative;
`;

const adornmentStyles = css`
  width: 16px;
  height: 16px;
  position: absolute;
  bottom: 0;
  right: 0;
  outline: none;
  transform: translate(-9px, -9px);
`;

const StyledLabel = styled.label`
  ${rootStyles}
  ${(p) =>
    p.endAdornment &&
    css`
      ${adornmentContainerStyles}

      & > *:last-child {
        ${adornmentStyles}
      }
    `}

  color: #364866;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;

  & > input {
    margin-top: 8px;
  }
`;

const AdornmentContainer = styled.div`
  ${rootStyles}
  ${adornmentContainerStyles}

  & > *:last-child {
    ${adornmentStyles}
  }
`;

const StyledInput = styled.input`
  ${(p) =>
    !p.label &&
    css`
      ${rootStyles}
    `}

  height: 35px;
  padding: 0 12px;
  color: #364866;
  background-color: #FFFFFF;
  border: 1px solid #D1D5DD;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  outline: none;

  &:focus {
    border-color: #0F9BF0;
  }

  &:read-only {
    color: #8A94A6;
  }

  &:disabled {
    background: #F7F8FA;
    border: 1px solid #E1E4E8;
    color: rgba(54, 72, 102, 0.5);
  }

  ${(p) =>
    p.error &&
    css`
      border-color: #C7053F;
    `}
`;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

const StyledImg = styled.img`
  margin: 0 4px 2px 0;
`;

export default TextInput;
